import {createContext} from 'react'
import type {ProjectId} from '@package/shared'
import type {DateRange} from '../../../../components/dateRangeSelector/DateRangeSelector.tsx'

type Context = {
  projectId: ProjectId | null
  setProjectId: (projectId: ProjectId | null) => void

  month: DateRange
  setMonth: (month: DateRange) => void
}

export const FiltersContext = createContext<Context>({} as Context)
